import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import classnames from 'classnames';

import { Link } from 'react-router-dom';

import {
    withStyles, Typography,
} from '@material-ui/core';

import urls from '../../../app/urls';
import { patientProgramElementGroups } from '../../../common/constants';

const styles = theme => ({
    root: {
        background: theme.palette.grey[100],
        padding: theme.spacing(2),
    },
    topContainer: {
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 500,
    },
    description: {
        marginBottom: theme.spacing(4),
    },
    content: {
    },

    tasks: {
        padding: theme.spacing(2),
        background: theme.palette.grey[100],
        minHeight: 300,
    },
    moduleTitle: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        borderBottom: theme.youwell.borders.dim,
        fontWeight: 500,
    },
    taskName: {
        paddingBottom: theme.spacing(0.5),
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(0.5),
        borderBottom: theme.youwell.borders.dim,
    },


});

class UnfinishedTasksBox extends React.Component {
    render() {
        const {
            classes, translate, className, elements,
        } = this.props;

        if (!elements || elements.length === 0) {
            return null;
        }

        return (
            <div className={classnames(classes.root, className)}>
                <div className={classes.topContainer}>
                    <Typography variant="h6" className={classes.title}>
                        {translate('dashboard.unfinishedTasks')}
                    </Typography>
                    <Typography className={classes.description}>
                        {translate('dashboard.unfinishedTasksDescription')}
                    </Typography>
                </div>
                <div className={classes.content}>
                    {elements.map(element => (
                        <div key={element.id} className={classes.moduleItem}>
                            <Link
                                className={classnames(this.props.classes.moduleLink)}
                                to={`${urls.inside.program}/${patientProgramElementGroups.main}/${element.indexInGroup}`}
                            >
                                <Typography variant="subtitle1" className={this.props.classes.moduleTitle}>
                                    {`${this.props.translate('favourites.module')}: ${element.moduleName}`}
                                </Typography>
                            </Link>
                            {element.tasks.map(task => (
                                <Link
                                    key={task.id}
                                    className={classnames(classes.taskLink)}
                                    to={`${urls.inside.program}/${patientProgramElementGroups.main}/${element.indexInGroup}/${task.taskIndex}`}
                                >
                                    <Typography variant="subtitle1" className={classes.taskName} color="primary">
                                        {task.name}
                                    </Typography>
                                </Link>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

UnfinishedTasksBox.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    elements: PropTypes.array.isRequired,
    className: PropTypes.string,
};

UnfinishedTasksBox.defaultProps = {
    className: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(UnfinishedTasksBox));
